import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';

export interface PolicyDomainAccessResponse {
  canEditAllDomains: boolean;
}

/** Whether the current user may create or save an all-domains policy. */
export function useFetchPolicyDomainAccess() {
  return useQuery({
    queryKey: [api.policyDomainAccess],
    queryFn: () =>
      fetchWrapper.get<PolicyDomainAccessResponse>(api.policyDomainAccess),
  });
}
